import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import Services from "@/pages/Services";
import About from "@/pages/About";
import ServiceAreas from "@/pages/ServiceAreas";
import Blog from "@/pages/Blog";
import Contact from "@/pages/Contact";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App noise min-h-screen" data-testid="app-root">
      <BrowserRouter>
        <SmoothScroll>
          <Nav />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/service-areas" element={<ServiceAreas />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#081A1A",
            border: "1px solid #1A3333",
            color: "#F0FAFA",
          },
        }}
      />
    </div>
  );
}

export default App;
